import { render, staticRenderFns } from "./DoubleColumns.vue?vue&type=template&id=46f80536&scoped=true"
import script from "./DoubleColumns.vue?vue&type=script&lang=js"
export * from "./DoubleColumns.vue?vue&type=script&lang=js"
import style0 from "./DoubleColumns.vue?vue&type=style&index=0&id=46f80536&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f80536",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/BudgetReport/DoubleColumns.vue
// module id = 2198
// module chunks = 31